<template>
  <transition
    name="fade"
    appear
  >
    <div
      v-if="show"
      v-cloak
      class="award-modal"
      data-cy="awards-notice"
    >
      <div
        @click="$emit('close')"
        class="mask"
      />
      <div class="body">
        <div class="header">
          <img
            src="@/assets/img/awards/award-modal-bg.jpeg"
            class="bg"
            alt=""
          />
          <c-button
            size="lg"
            icon="cross"
            class="close"
            ghost
            @click="$emit('close')"
            data-cy="close-awards-notice"
          />
        </div>
        <div class="award">
          <img
            src="@/assets/img/awards/award-img.png"
            alt=""
          />
          <div class="content">
            <div class="text">
              <img
                src="@/assets/img/awards/magic_button.png"
                alt=""
              />
              <h4>Premio</h4>
            </div>
            <h2 class="value">
              {{ awardValue }}
            </h2>
          </div>
        </div>
        <div class="content">
          <h1 class="title">
            {{ notice.name }}
          </h1>
          <p class="subtitle">
            {{ notice.message }}
          </p>

          <p
            class="author"
          >
            Concendido por: <span>{{ notice.provided_by }}</span>
          </p>
          <k-button
            class="round-kbutton"
            type="small"
            @click.native="clickButton"
          >
            Saiba mais
          </k-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import toMoney from '@helpers/toMoney'
import { KButton } from '@/components/KaledoComponents'

export default {
  name: 'AwardModal',
  components: {
    KButton
  },
  props: {
    show: Boolean,
    notice: Object,
    companySlug: String
  },
  computed: {
    awardValue () {
      const value = (this.notice.value / 100)
      const valueFormated = value.toFixed(2)
      return toMoney(valueFormated)
    }
  },
  methods: {
    clickButton () {
      window.dataLayer.push({
        event: 'premios-popup-click',
        company_slug: this.companySlug
      })
      this.$router.push({ name: 'Carteira Prêmios' })
      this.$emit('close')
    }
  }
}
</script>

<style lang='scss'>
@import '~@style/reference';
.award-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-height: 100%;
  overflow: hidden;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  [v-cloak] > * { display:none; }
  .mask {
    z-index: 10;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    background-color: rgba(black, 0.5);
  }
  .body {
    z-index: 11;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    min-width: 560px;
    border-radius: 4px;
    background: white;

    @include mobile {
      min-width: 300px;
      margin: 0 22px;
    }
    .header {
      .bg {
        border-radius: 4px 4px 0px 0px;
        @include mobile {
          max-width: 100%;
          height: 110px;
          object-fit: cover;
        }
      }
    }
    .close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px;

      & > .icon { fill: white !important }
    }
    .award {
      background: rgba(18, 30, 72, 1);
      background: var(--color-primary);
      width: 180px;
      height: 80px;
      margin: -46px auto 0px auto;
      position: relative;
      z-index: 11;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      @include mobile {
        margin-top: -32px;
      }
      .content {
        color: white;
        margin: 10px 16px 10px 20px;
        text-align: center;
        width: 100%;
        .text {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
        }

      }
    }
    .content {
      text-align: center;
      margin-top: 16px;
      padding-bottom: 32px;
      @include mobile {
        margin: 16px 16px 0px 16px;
      }
      .title {
        font-size: 16px;
        color: $title-color;
        margin-bottom: 16px;
      }
      .subtitle {
        font-size: 13px;
        margin-bottom: 16px;
      }
      .author {
        color: $primary-color-placeholder;
        font-size: 12px;
        margin-bottom: 16px;
        span {
          font-size: 10px;
          @include mobile {
            margin-top: 4px;
            display: block
          }
        }
      }
      .round-kbutton {
        width: 115px;
        background: var(--color-primary);
        border-radius: 30px;
        font-size: 12px;
        font-weight: 400;
        padding: 0 16px;
        text-align: right;
        .icon {
          left: 15px;
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/containers/Notices/AwardModal.vue